export const TOKEN = 'TOKEN';
export const API_DOMAIN = `${process.env.REACT_APP_API_DOMAIN}`;
export const ROOT_DOMAIN = `${process.env.REACT_APP_ROOT_DOMAIN}`;
export const VERSION = `${process.env.REACT_APP_VERSION}`;
export const MODULE_PER_ROW =
  Number.parseInt(`${process.env.REACT_APP_MODULE_PER_ROW}`) || 3;

export const EXPIRED_TIME = 'EXPIRED_TIME';

export const SITE_LAT_DEFAULT = 14.0583;
export const SITE_LNG_DEFAULT = 108.2772;

export const TABLE_ROW_AMOUNT = 10;

export const ITEM_TABLE_IN_STOCK_STATUS = 'inStock';
export const ITEM_TABLE_BORROWING_STATUS = 'borrowing';
export const ITEM_TABLE_SERVICING_STATUS = 'servicing';

export const DATE_TIME_FORMAT = 'DD MM YYYY HH:mm A';

//-----------------------------------------------------
export const NARROW_SCREEN_SIZE = 1100;
export enum CookiesName {
  NAME = 'system-token',
  TOKEN = 'TOKEN_SYSTEM',
  EXPIRED_TIME = 'EXPIRED_TIME',
  PERMISSION_LIST = 'PERMISSION_LIST',
  ROLE = 'Role',
}

export type RequestStatus = 'pending' | 'fulfilled' | 'rejected';
export interface RequestLoading<T> {
  name?: T;
  status?: RequestStatus;
  loading: boolean;
  error?: unknown;
}
